module.exports = __webpack_public_path__ + "static/assets/8e86be74a94253241b74f716df03e777.svg";